import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import NotFound, { ErrorType } from 'pages/notFound/NotFound';
import Modals from '../components/modal/Modals';
import GoogleAnalyticsHandler from './GoogleAnalyticsHandler';
import PageTitleHandler from './PageTitleHandler';
import WindowMessagesHandler from './WindowMessagesHandler';
import RootRouteRedirectionsHandler from './RootRouteRedirectionsHandler';

const RoutesWrapper = () => {
  return (
    <ErrorBoundary fallback={<NotFound errorType={ErrorType.ERROR} />}>
      <PageTitleHandler />
      <RootRouteRedirectionsHandler />
      <WindowMessagesHandler />
      <GoogleAnalyticsHandler />
      <Outlet />
      <Modals />
    </ErrorBoundary>
  );
};

export default RoutesWrapper;
